/* import __COLOCATED_TEMPLATE__ from './unassign-unsnoozed-setting.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

interface Args {
  unassignUnsnoozedAtCapacityEnabled: boolean;
  unassignUnsnoozedAtCapacityUpdate(value: boolean): void;
  unassignUnsnoozedWhenAwayEnabled: boolean;
  unassignUnsnoozedWhenAwayUpdate(value: boolean): void;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class UnassignUnsnoozedSetting extends Component<Signature> {
  @service declare appService: AppService;

  get showWhenAwayToggle() {
    return this.appService.app.canUseFeature('inbox-unassign-unsnooze-when-away');
  }

  @action
  toggleUnassignUnsnoozedAtCapacity() {
    let newValue = !this.args.unassignUnsnoozedAtCapacityEnabled;
    this.args.unassignUnsnoozedAtCapacityUpdate(newValue);
  }

  @action
  toggleUnassignUnsnoozedWhenAway() {
    let newValue = !this.args.unassignUnsnoozedWhenAwayEnabled;
    this.args.unassignUnsnoozedWhenAwayUpdate(newValue);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox::WorkloadManagement::UnassignUnsnoozedSetting': typeof UnassignUnsnoozedSetting;
    'inbox/workload-management/unassign-unsnoozed-setting': typeof UnassignUnsnoozedSetting;
  }
}
